const announcement = {
  state: () => ({
    editAnnouncementData: {},
    showFirstTimeEditDataForAnnouncement: true
  }),

  getters: {
    editAnnouncementData(state) {
      return state.editAnnouncementData;
    },
    showFirstTimeEditDataForAnnouncement(state) {
      return state.showFirstTimeEditDataForAnnouncement;
    }
  },

  mutations: {
    saveEditAnnouncement(state, data) {
      state.editAnnouncementData = data;
    },
    showFirstTimeEditDataForAnnouncement(state) {
      state.showFirstTimeEditDataForAnnouncement = true;
    },

    removeFirstTimeEditDataForAnnouncement(state) {
      state.showFirstTimeEditDataForAnnouncement = false;
    }
  }
};

export default announcement;
